<template>
  <div class="container">
    <h1>
      <b-icon icon="file-earmark-spreadsheet"></b-icon> Course Attendance

      <div class="float-right" style="margin-top: -62px;">
        <b-button v-b-modal.modal-help v-b-tooltip.hover title="Help" class="help">
          <b-icon icon="question-square-fill"></b-icon> Help
        </b-button>
        <Help id="10" />
      </div>
    </h1>

    <div class="text-center" v-if="isLoading">
      <b-spinner variant="primary" label="Text Centered"></b-spinner>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="panal mt-20">
          <div class="panal-header">Your Currently Courses</div>
          <div class="panal-body">
            <div v-if="message" class="alert" :class="successful ? 'alert-success' : 'alert-danger'">
              {{ message }}
            </div>

            <div class="row">
              <div class="col-md-4">
                <div class="card">
                  <div class="card-header">
                    Bioscience 2
                  </div>
                  <div class="card-body">
                    <p class="card-text">Course Code : DES1203.</p>
                    <p class="card-text">Course Room : 0000.</p>
                    <button class="btn btn-primary" @click="startScanner">Attend Now (Start Scanner)</button>

                    <!-- QR Code Stream, only displayed when scannerActive is true -->
                    <!-- <div v-if="scannerActive">
                      <qrcode-stream @decode="onDecode" @init="onInit" />
                    </div> -->
                    <p>{{ error }}</p>
                    <!-- <qrcode-stream @init="onInit" @camera-on="onReady"></qrcode-stream> -->
                    <!-- <qrcode-stream></qrcode-stream>
<qrcode-drop-zone></qrcode-drop-zone>
<qrcode-capture></qrcode-capture> -->

                    Display QR result 
                     <p v-if="qrResult">Scanned QR Code: {{ qrResult }}</p>
                    <p v-if="error">Error: {{ error }}</p>
                  </div>
                </div>
              </div>  
               <!-- Additional course cards... -->
            </div>

            <div class="col-md-12 text-center mt-3">
              <b-button class="btn btn-primary" @click="goBack">Go Back</b-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import studentData from "../../services/student/studentDataServices";
import Help from "../Help.vue";
// import QrcodeStream from 'vue3-qrcode-reader';

export default {

  components: { 
    Help,  
    // QrcodeStream,
  
  },
  name: "courseAttend",
  data() {
    return {
      isLoading: true,
      message: "",
      qrResult: null, // Holds the decoded QR result
      error: null, // Holds any error message
      scannerActive: false, // Controls whether the QR code scanner is active
    };
  },
  mounted() {
    // Fetch student data
    studentData.GetStudentData(this.currenUser.StudentID).then(
      (Response) => {
        this.isLoading = false;
        this.personalData = Response.data.StudentData;
      },
      (error) => {
        this.message =
          (error.response && error.response.data && error.response.data.Message) ||
          error.message ||
          error.toString();

        if (error.response.status == 404) this.message = "";
      }
    );

    // Fetch absence data or other student-related information if needed
    studentData.GetAbsencePercentage(this.currenUser.StudentID).then(
      (Response) => {
        this.isLoading = false;
        this.courses = Response.data;
      },
      (error) => {
        this.message =
          (error.response && error.response.data && error.response.data.Message) ||
          error.message ||
          error.toString();

        if (error.response.status == 404) this.message = "";
      }
    );
  },
  methods: {
    goBack() {
      this.$router.back(); // Go back to the previous page
    },

    // Start the scanner when the button is clicked
    startScanner() {
      this.scannerActive = true;
    },

    // Called when QR code is successfully decoded
    onDecode(decodedString) {
      this.qrResult = decodedString;
      this.error = null; // Clear any previous errors
      this.scannerActive = false; // Deactivate the scanner after successful scan
    },
  //   onReady(capabilities) {
  //   // hide loading indicator
  // },
    // Called when there is an error in QR code reading
   // Called when there is an error in QR code reading
   async onInit(promise) {
      try {
        await promise; // Await the promise to ensure it resolves before continuing
      } catch (error) {
        this.handleScannerError(error);
      }
    },

    handleScannerError(error) {
      switch (error.name) {
        case 'NotAllowedError':
          this.error = "User denied camera access permission";
          break;
        case 'NotFoundError':
          this.error = "No suitable camera device installed";
          break;
        case 'NotSupportedError':
          this.error = "Page is not served over HTTPS (or localhost)";
          break;
        case 'NotReadableError':
          this.error = "Maybe camera is already in use";
          break;
        case 'OverconstrainedError':
          this.error = "Did you request the front camera although there is none?";
          break;
        case 'StreamApiNotSupportedError':
          this.error = "Browser lacks necessary features for QR scanning";
          break;
        default:
          this.error = "An unknown error occurred";
      }
      this.scannerActive = false; // Deactivate the scanner in case of error
    }
  },
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.help {
  color: #fff;
  background-color: #ff8600;
  /* padding: 2px 16px; */
}

h1 {
  color: #285475;
  font-size: 25px;
  border-bottom: 1px #646464 dashed;
  padding: 10px 0px;
}

h1 a {
  color: #ff8600;
}

.panal {
  background: #fff;
  border-radius: 10px;
  color: #fff;
  padding: 0px 0px 20px 0px;
  margin: 10px 0;
  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  margin-bottom: 20px !important;
}

.panal-header {
  background: #285475;
  color: #ffffff;
  text-align: left;
  border-radius: 10px 0px 0px 0px;
  padding: 10px 20px;
  font-size: 17px;
  font-weight: bold;
  width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}

.panal-body {
  padding: 20px;
  color: #333;
}

.app-stu-photo {
  float: right;

  border-radius: 10px;
  border: 1px solid #111;

}

.app-stu-photo img {
  width: 100%;
  border-radius: 10px;
}

.app-All {
  width: 75%;
  float: left;
}

.app-stu {
  border-bottom: 1px #333 dotted;
  padding: 10px 0px;

  float: left;
}

.app-stu .title {
  font-weight: bold;
}

.app-stu .title span {
  font-weight: 100;
}

.table .thead-dark th {
  color: #fff;
  background-color: #dee2e6 !important;
  border-color: #989899 !important;
  font-size: 13px !important;
}

.table .thead-light th {
  color: #495057;
  background-color: #e9ecef;
  border-color: #dee2e6;
  font-size: 13px !important;
}

.bg-filter {
  background: #cacaca;
  padding: 10px;
  width: 100%;
}

.show {
  display: none;
}

.profileData,
.profileData2 {
  border: 1px dotted #646464;
  padding: 3px 10px;
  font-weight: 700;
  margin: 5px 0px;
}

.profileData {
  color: #285475;
}

.profileData2 {
  color: #ff8600;
}


@media only screen and (max-width: 600px) {
  .panal-header {
    width: 90% !important;
  }

  .app-stu-photo {
    float: none;



  }
}

.model {
  background: rgba(30, 143, 255, 0.13);
  height: 1px;
  overflow: hidden;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  transition: width 1s ease 1s, height 1s ease;
  width: 0;
  z-index: 133;
}

.content {
  color: transparent;

  font-size: 2em;
  position: absolute;
  top: 50%;
  left: 25%;
  transform: translate3d(0, -50%, 0);
  transition: color 0.5s ease;
  width: 50%;
  margin: auto;
}

label {
  color: rgba(30, 143, 255, 0.13);
  cursor: pointer;
  font-family: "Consolas", arial, sans-serif;
  font-size: 2em;
  position: fixed;
  left: 50%;
  top: 50%;
  text-transform: uppercase;
  transform: translate(-50%, -50%);
  transition: color 0.5s ease 0.5s;
}

input {
  cursor: pointer;
  height: 0;
  opacity: 0;
  width: 0;
}

input:focus {
  outline: none;
}

input:checked {
  height: 40px;
  opacity: 1;
  position: fixed;
  right: 20px;
  top: 20px;
  z-index: 1;
  -webkit-appearance: none;
  width: 40px;
  z-index: 135;
}

input:checked::after,
input:checked:before {
  border-top: 1px solid #FFF;
  content: "";
  display: block;
  position: absolute;
  top: 50%;
  transform: rotate(45deg);
  width: 100%;
}

input:checked::after {
  transform: rotate(-45deg);
}

input:checked+label {
  color: #FFF;
  transition: color 0.5s ease;
}

input:checked~.model {
  height: 100%;
  width: 100%;
  transition: width 1s ease, height 1s ease 1s;
}

input:checked~.model .content {
  color: #FFF;
  transition: color 0.5s ease 0.5s;
}

.btn-primary {
  color: #fff;
  background-color: #007bff !important;
  border-color: #007bff !important;
}
</style>